// Sessiya ma'lumoti localStorage'da.
//
// NEGA localStorage, httpOnly cookie EMAS: xsib-admin bilan bir xil sabab —
// ilova backend bilan boshqa origin'da (subdomen) ishlashi mumkin.
//
// ⚠️ KALIT NOMI BOSHQA UCH ILOVANIKIDAN ATAYLAB FARQ QILADI ("xsib-partner."
// prefiksi; admin'da "xsib.", kabinetda "xsib-selfcare."). Ular bir
// brauzerda ochilishi mumkin — reseller o'z abonentligini ham shu
// qurilmadan tekshirsa, yoki dasturchi hammasini lokalda yursa. Kalitlar
// to'qnashsa, biri tokenini ikkinchisiga yozib, ikkalasini ham
// chalkashtirib qo'yardi.
//
// ⚠️ Sherik tokeni O'Z AUDITORIYASIGA ega (ADR-029 §4) — ya'ni admin
// tokeni bu yerga qo'yilsa ham server uni rad etadi. Kalitni ajratish
// esa buni SO'RAMASDAN OLDIN, brauzerdayoq hal qiladi.
const TOKEN_KEY = 'xsib-partner.token'
const EXPIRES_KEY = 'xsib-partner.expiresAt'
/**
 * 14 kunlik yangilash tokeni.
 *
 * ⚠️ Panel uni HOZIRCHA faqat CHIQISHDA ishlatadi: `AuthResource#logout`
 * uni `@NotBlank` qilib talab qiladi va usiz so'rov 400 bo'lardi, ya'ni
 * server tomonda sessiya UMUMAN bekor qilinmasdi.
 *
 * ⚠️ Avtomatik yangilash ULANGAN (`client.ts` → `sessionRefresh.ts`),
 * ya'ni bu qiymat sessiyani 12 soatgacha uzaytiradi.
 *
 * ⛔ Bu izoh 2026-08-23 gacha «yangilash hali ULANMAGAN» derdi va
 * o'sha eskirgan faraz {@link hasValidToken} da qotib qolgan edi: u
 * muddati o'tgan tokenda butun sessiyani, refresh bilan birga,
 * o'chirib tashlardi. Natijada sherik har 15 daqiqada qaytadan parol
 * terardi — sabab esa shu bitta izohda «yozib qo'yilgan» edi.
 */
const REFRESH_KEY = 'xsib-partner.refreshToken'

function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // localStorage yopiq bo'lsa sessiya faqat shu yorliqda yashaydi
  }
}

function remove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // e'tiborsiz
  }
}

export function getToken(): string | null {
  return read(TOKEN_KEY)
}

export function getExpiresAt(): string | null {
  return read(EXPIRES_KEY)
}

export function getRefreshToken(): string | null {
  return read(REFRESH_KEY)
}

export function saveSession(
  token: string,
  expiresAt?: string | null,
  refreshToken?: string | null,
): void {
  write(TOKEN_KEY, token)
  // Muddat berilmasa ESKISI O'CHIRILADI: qolib ketsa yangi sessiya eski
  // (allaqachon o'tgan) muddat bilan darhol "tugagan" deb hisoblanardi
  if (expiresAt) write(EXPIRES_KEY, expiresAt)
  else remove(EXPIRES_KEY)
  // ⚠️ Refresh tokeni ham SHU QOIDA bo'yicha: qolib ketsa u ALLAQACHON
  // boshqa sessiyaga tegishli qiymat bo'lardi va uni yuborish server
  // uchun REPLAY ko'rinardi.
  if (refreshToken) write(REFRESH_KEY, refreshToken)
  else remove(REFRESH_KEY)
}

export function clearSession(): void {
  remove(TOKEN_KEY)
  remove(EXPIRES_KEY)
  remove(REFRESH_KEY)
}

/**
 * Token muddati o'tganmi.
 *
 * ⚠️ Token YO'Q bo'lsa `false` qaytaradi — "muddati o'tgan" va "umuman yo'q"
 * boshqa-boshqa holatlar. Chaqiruvchi (`client.ts`) ikkalasini alohida
 * tekshiradi.
 */
export function isTokenExpired(): boolean {
  const expiresAt = getExpiresAt()
  if (!expiresAt) return false
  const ts = Date.parse(expiresAt)
  return !Number.isNaN(ts) && ts <= Date.now()
}

/**
 * Sessiya davom etyaptimi.
 *
 * Bu FAQAT ortiqcha so'rov yubormaslik uchun — haqiqiy tekshiruv serverda.
 *
 * <h2>⛔ MUDDATI O'TGAN TOKEN — SESSIYA TUGADI DEGANI EMAS</h2>
 *
 * Ilgari bu yerda muddati o'tgan tokenda darhol {@code clearSession()}
 * chaqirilardi — u esa REFRESH TOKENNI HAM o'chiradi. Natijada:
 *
 *   15 daqiqadan keyin panel o'zi tekshiradi → muddati o'tgan →
 *   butun sessiya o'chadi → sherik kirish ekraniga qaytadi.
 *
 * Yangilash (`client.ts`) esa faqat **401 javobida** ishga tushardi va
 * unga navbat HECH QACHON yetmasdi: so'rov yuborilishidan oldin sessiya
 * allaqachon o'chirilgan bo'lardi.
 *
 * ⚠️ Jonli o'lchov (Staging, 2026-08-23): `identity.refresh_token` da
 * `reseller_nurbek` uchun uch soatda UCH qator, hammasi yangi KIRISH,
 * `replaced_by` esa BO'SH — ya'ni yangilash bir marta ham urinib
 * ko'rilmagan. Refresh muddati 12 soat bo'lsa ham, sherik har 15
 * daqiqada qaytadan parol terardi.
 *
 * ⚠️ Admin panelida bu qator ALLAQACHON bor
 * (`frontend/admin/.../tokenStorage.ts`) — shuning uchun u yerda sessiya
 * yashardi. Sherik moduli undan nusxa emas (11-SHERIK-KABINETI-UI.md
 * §10.5) va aynan shu bitta qator tushib qolgan.
 */
export function hasValidToken(): boolean {
  if (!getToken()) return false
  if (isTokenExpired()) {
    // Refresh tokeni bor — sessiya TIRIK. Yangilashni `client.ts`
    // birinchi 401 da bajaradi; bu yerda uni o'ldirib qo'ymaymiz.
    if (getRefreshToken()) return true
    clearSession()
    return false
  }
  return true
}
